import { render, staticRenderFns } from "./Sessie.vue?vue&type=template&id=039caee8&"
import script from "./Sessie.vue?vue&type=script&lang=js&"
export * from "./Sessie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039caee8')) {
      api.createRecord('039caee8', component.options)
    } else {
      api.reload('039caee8', component.options)
    }
    module.hot.accept("./Sessie.vue?vue&type=template&id=039caee8&", function () {
      api.rerender('039caee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Sessies/Sessie.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sessies/Sessie.vue
// module id = 364
// module chunks = 0